import { RollupId, TmRollupResponse } from '@business/entities/tm/TmRollupResponse';
import { Endpoint } from '../endpoint';

export function fetchRollups() {
  return Endpoint.get<TmRollupResponse[]>(`@gc/rollups`);
}

export function fetchRollup(id: RollupId) {
  return Endpoint.get<TmRollupResponse>(`@gc/rollups/rollup/${id}`);
}

export function createRollup(data: Partial<TmRollupResponse>) {
  return Endpoint.post<TmRollupResponse>(`@gc/rollups`, { data });
}

export function updateRollup(id: RollupId, data: Partial<TmRollupResponse>) {
  return Endpoint.patch<TmRollupResponse>(`@gc/rollups/${id}`, { data });
}

export function deleteRollup(id: RollupId) {
  return Endpoint.delete<void>(`@gc/rollups/${id}`);
}
